module.exports = __webpack_public_path__ + "static/media/31-5.a48d9171.mp3";